import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { get } from "lodash";

import { required, isDec, max64 } from "../../../../constants/formValidators";
import { FormField } from "../../../../sharedComponents/formField";
import { foodTypeList } from "../../../../constants/recipeConstants";
import {
	getFoodGroupList,
	getFoodDatabaseLevelTwo,
	getFoodDatabaseLevelThree,
	saveFoodItem,
	saveMyFoodItem,
	addFoodItem,
	addMyFoodItem,
	resetField,
} from "../../../../store/actions";

const FoodDetails = ({
	handleSubmit,
	hier1,
	hier2,
	hier3,
	getFoodGroupList,
	getFoodDatabaseLevelTwo,
	getFoodDatabaseLevelThree,
	setActiveTab,
	initialValues,
	saveFoodItem,
	saveMyFoodItem,
	addFoodItem,
	addMyFoodItem,
	change,
	resetField,
	isAdmin,
	history,
	isView
}) => {
	const [submitting, setSubmitting] = useState(false);
	const match = window.location.href;
	const isApproval = match.indexOf("/approval") > -1 ? true : false;

	useEffect(() => {
		getFoodGroupList();
	}, [getFoodGroupList]);

	useEffect(() => {
		if (initialValues && initialValues.hier1) {
			getFoodDatabaseLevelTwo(`p_id=${initialValues.hier1} `);
			if (initialValues.hier2) {
				getFoodDatabaseLevelThree(`p=${initialValues.hier2}`);
			}
		}
	}, [getFoodDatabaseLevelThree, getFoodDatabaseLevelTwo, initialValues]);

	const validateForm = (values) => {
		if(values.upc_code !== undefined && values.upc_code === "") {
			values.upc_code = null
		}

		setSubmitting(true);
		const successHandler = (res) => {
			res.json().then((data) => {
				isApproval
					? history.push(`/nutrition/food-database/approval/${data.id}/add`)
					: history.push(`/nutrition/food-database/${data.id}/add`);
				setSubmitting(false);
				setActiveTab(1);
			});
		};

		if (initialValues && initialValues.id) {
			if (initialValues === values) {
				setSubmitting(false);
				setActiveTab(1);
			} else {
				if (isAdmin) {
					saveFoodItem(values, successHandler);
				} else {
					saveMyFoodItem(values, successHandler);
				}
			}
		} else {
			if (isAdmin) {
				addFoodItem(values, successHandler);
			} else {
				addMyFoodItem(values, successHandler);
			}
		}
	};

	const nextTab = () => {
		setActiveTab(1);
	}

	const upcCodeView = () => {
		return (
			<Field
				label="UPC"
				name="upc_code"
				type={isView ? "label" : "text"}
				validate={[]}
				formGroupClass={isView ? "col-8 foodlistview_label" : "col-6"}
				component={FormField}
				onChange={() => setSubmitting(false)}
			/>
		)
	}

	const usefulView = () => {
		return (
			<span className={isView ? "dissabledFields" : ""}>
				<Field
					label="Useful"
					name="useful"
					type="checkbox"
					formGroupClass={isView ? "col-4" : "col-4 mt-4 pt-1"}
					component={FormField}
					onChange={() => setSubmitting(false)}
				/>
			</span>
		)
	}

	return (
		<form className="p-4" onSubmit={handleSubmit(validateForm)}>
			<div className="row">
				<Field
					label="Name"
					name="name"
					type={isView ? "label" : "text"}
					formGroupClass={isView ? "col-8 foodlistview_label" : "col-8"}
					component={FormField}
					validate={[required, max64]}
					onChange={() => setSubmitting(false)}
				/>
			</div>
			<div className="row">
				<Field
					name="long_desc"
					label="Long Description"
					type={isView ? "label" : "textarea"}
					component={FormField}
					formGroupClass={isView ? "col-8 foodlistview_label" : "col-8"}
					validate={[required]}
					onChange={() => setSubmitting(false)}
				/>
			</div>
			<div className="row">
				<Field
					label="Base Weight in GRAMS"
					name="base_weight"
					type={isView ? "label" : "number"}
					formGroupClass={isView ? "col-8 foodlistview_label" : "col-8"}
					min="0"
					max="9999"
					component={FormField}
					validate={[]}
					onChange={() => setSubmitting(false)}
				/>
			</div>
			{isAdmin ? (
				<>
					{
						isView
							?
							<>
								<div className="row">
									{upcCodeView()}
								</div>
								<div className="row">
									{usefulView()}
								</div>
							</>
							:
							<div className="row">
								{upcCodeView()}
								{usefulView()}
							</div>
					}
					<div className="row">
						<Field
							label="Data Source"
							name="source"
							type={isView ? "label" : "text"}
							validate={[required]}
							formGroupClass={isView ? "col-8 foodlistview_label" : "col-8"}
							component={FormField}
							onChange={() => setSubmitting(false)}
						/>
					</div>
					<div className="row">
						<Field
							label="Web Link"
							name="link"
							type={isView ? "label" : "text"}
							formGroupClass={isView ? "col-8 foodlistview_label" : "col-8"}
							component={FormField}
							onChange={() => setSubmitting(false)}
						/>
					</div>
				</>
			) : null}
			<div className="text-right">
				{
					isView
						?
						<button type="button" className="btn btn-primary-dark text-uppercase" onClick={nextTab}>
							Next
						</button>
						:
						<button type="submit" className="btn btn-primary-dark text-uppercase" disabled={submitting}>
							Save & Next
						</button>
				}
			</div>
		</form>
	);
};

const mapStateToProps = (state) => {
	return {
		hier1: get(state, "AddRecipe.recipeFoodGroups", []),
		hier2: get(state, "FoodDatabase.foodDatabaseLevel2Result.results", []),
		hier3: get(state, "FoodDatabase.foodDatabaseLevel3Result.sub_category", []),
	};
};

const mapDispatchToProps = {
	getFoodGroupList,
	getFoodDatabaseLevelTwo,
	getFoodDatabaseLevelThree,
	saveFoodItem,
	saveMyFoodItem,
	addFoodItem,
	addMyFoodItem,
	resetField,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: "FoodDetails",
		enableReinitialize: true,
	})(FoodDetails)
);
